import React, { useContext, useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { popupcontext } from "../../../../context/Popupscontext";
import Form from "../../../Helpers/Form/Form";
import FormHeader from "../../../Helpers/Form/FormParts/FormHeader";
import trans, { formatTimeFromDate, isRTL } from "../../../../utils";
import Button from "../../../Helpers/Button/Button";
import {
  DatePickerInput,
  Input,
  InputDate,
} from "../../../Helpers/Input/Input";
import PhoneInput from "react-phone-input-2";
import UpdatePic from "../../../Helpers/UploadPic/UpdatePic";
import {
  InputSelect,
  TimePickerInput,
} from "../../../Helpers/Input/RefactoredInput";
import SkillsFormSection from "./skillsSection";
import { Flex, Segmented, TimePicker } from "antd";
import {
  FieldArray,
  Formik,
  Form as FormikForm,
  useFormikContext,
} from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import ShiftPopup from "./ShiftPopup";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { CountryOptions, dayOptions } from "../../../../constants";
import {
  useDeleteAttachmentMutation,
  useEditTechnicianMutation,
  useGetAvailableDevicesQuery,
  useGetSingleTechnicianQuery,
  useRegisterTechnicianMutation,
} from "../../../../Redux/service/Technician/Technician";
import { toast } from "react-toastify";
import Loader from "../../../Helpers/Loader/Loader";
import FileUploader from "../../../Helpers/Dropzone/FileUploader";
import UploadedDocuments from "./UploadedDocuments";
import { useGetChildVehiclesQuery } from "../../../../Redux/service/Vehicles/Vehicles";
import { useUsers } from "../../../../hooks/useUsers";
import TimePickerMUI from "../../../Helpers/Input/TimePicker";

const steps = [
  trans("Technician Details"),
  trans("Job Info"),
  trans("Device Assignment"),
  trans("System Access"),
];

const options = [
  { label: trans("Electrical"), value: "electrical" },
  { label: trans("Plumbing"), value: "plumbing" },
  { label: trans("HVAC"), value: "HVAC" },
];

const roles = [
  { label: trans("Technician"), value: "Technician" },
  { label: trans("Supervisor"), value: "Read-only Technician" },
  { label: trans("Contractor"), value: "contractor" },
  { label: trans("Sub-Contractor"), value: "subContractor" },
  { label: trans("QA"), value: "qa" },
  { label: trans("Consultant"), value: "consultant" },
];

const contractType = [
  { label: trans("Full Time"), value: "full_time" },
  { label: trans("Part Time"), value: "part_time" },
  { label: trans("Outsourced"), value: "outsourced" },
];

const deviceAssignmentOptions = [
  { label: trans("Assign Existing Device"), value: "assign_existing" },
  { label: trans("Register New Hardware"), value: "register_hardware" },
  { label: trans("Enable Mobile App"), value: "enable_mobile" },
  { label: trans("No Device"), value: "no_device" },
];

const hardwareDeviceTypes = [
  { label: trans("Personal Tracker"), value: "personal_tracker" },
  { label: trans("Wearable Tracker"), value: "wearable_tracker" },
  { label: trans("Handheld GPS"), value: "handheld_gps" },
  { label: trans("Safety Beacon"), value: "safety_beacon" },
  { label: trans("Asset Tag"), value: "asset_tag" },
  { label: trans("Mobile"), value: "mobile" },
  { label: trans("Tablet"), value: "tablet" },
];

function PersonalDetailsStep({ setPicUpdated }) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
  } = useFormikContext();

  const handlePictureSelect = (file) => {
    setFieldValue("profile_photo", file);
  };

  const getImageUrl = () => {
    if (values.profile_photo instanceof File) {
      return URL.createObjectURL(values.profile_photo);
    }
    if (
      typeof values.profile_photo === "string" &&
      values.profile_photo !== ""
    ) {
      return `${process.env.REACT_APP_BACKEND_URL}/${values.profile_photo}`;
    }
    return null;
  };

  return (
    <div className="form-section">
      <UpdatePic
        onPictureSelect={handlePictureSelect}
        picture={getImageUrl()}
        setPicUpdated={setPicUpdated}
      />
      <div className="row">
        <div className="col-lg-6">
          <Input
            title={trans("Name")}
            type="text"
            placeholder={trans("Ex. Ahmed Ali")}
            formstyle="form-input"
            id="name"
            name="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.name}
            touched={touched.name}
          />
        </div>
        <div className="col-lg-6">
          <Input
            title={trans("Email")}
            type="email"
            placeholder="Ex@gmail.com"
            formstyle="form-input"
            id="email"
            name="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.email}
            touched={touched.email}
          />
        </div>
        <div className="col-lg-6">
          <div
            className={`position-relative form-input ${
              touched.phone && errors.phone && "form-error"
            }`}
          >
            <label className="form-label text-capitalize">
              {trans("phone number")}
            </label>
            <div dir="ltr">
              <PhoneInput
                country={"ae"}
                id="phone"
                name="phone"
                disableCountryCode
                countryCodeEditable={true}
                enableSearch={true}
                disableSearchIcon
                onBlur={() => setFieldTouched("phone", true)}
                onChange={(val) => setFieldValue("phone", val)}
                value={values.phone}
              />
            </div>
            {touched.phone && errors.phone ? (
              <div className="validation">{trans(errors.phone)}</div>
            ) : null}
          </div>
        </div>
        <div className="col-lg-6">
          <Input
            title={trans("National ID")}
            type="text"
            placeholder={trans("Ex. 12333")}
            formstyle="form-input"
            id="national_id"
            name="national_id"
            value={values.national_id}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.national_id}
            touched={touched.national_id}
          />
        </div>
        <div className="col-lg-6">
          <Input
            title={trans("Employee Code")}
            type="text"
            placeholder={trans("Ex. 12333")}
            formstyle="form-input"
            id="employee_id"
            name="employee_id"
            value={values.employee_id}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.employee_id}
            touched={touched.employee_id}
          />
        </div>
        <div className="col-lg-6 select-z-index">
          <InputSelect
            id="specialization"
            name="specialization"
            label="Specialization"
            placeholder="Select specialization"
            options={options}
            value={values.specialization}
            onChange={(val) => setFieldValue("specialization", val)}
            onBlur={() => setFieldTouched("specialization", true)}
            errors={errors.specialization}
            touched={touched.specialization}
            formstyle="form-input"
          />
        </div>
        <SkillsFormSection />
      </div>
    </div>
  );
}

function JobDetailsStep({
  isEditing,
  oldDocuments,
  removedDocs,
  setRemovedDocs,
}) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
  } = useFormikContext();
  const { openShiftPopup, setOpenShiftPopup } = useContext(popupcontext);

  const { data, isFetching } = useGetChildVehiclesQuery();
  const { managerOptions } = useUsers();
  const usersDropdown =
    data?.map((s) => ({
      label: s?.user.name,
      value: Number(s?.user.id),
    })) || [];

  const handleFileChange = (files) => {
    setFieldValue("documents", files);
  };

  return (
    <>
      <div className="form-section">
        <div className="row">
          <div className="col-lg-6">
            <Input
              title={trans("Job Title")}
              type="text"
              placeholder={trans("Ex. Electrician")}
              formstyle="form-input"
              id="job_title"
              name="job_title"
              value={values.job_title}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors.job_title}
              touched={touched.job_title}
            />
          </div>
          <div className="col-lg-6">
            <Input
              title={trans("department")}
              type="text"
              placeholder={trans("Ex. Maintenance")}
              formstyle="form-input"
              id="department"
              name="department"
              value={values.department}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors.department}
              touched={touched.department}
            />
          </div>
          <div className="col-lg-6 select-z-index">
            <InputSelect
              id="work_location"
              name="work_location"
              label="work location"
              placeholder={trans("Select Work Location")}
              options={CountryOptions}
              value={values.work_location}
              onChange={(val) => setFieldValue("work_location", val)}
              onBlur={handleBlur}
              touched={touched.work_location}
              errors={errors.work_location}
              formstyle="form-input"
            />
          </div>
          <div className="col-lg-6 select-z-index">
            {/* {managerOptions ? (
              <InputSelect
                id="supervisor_id"
                name="supervisor_id"
                label="Supervisor"
                placeholder="Select Supervisor"
                options={managerOptions}
                value={values.supervisor_id}
                defaultValue={values.supervisor_id}
                onChange={(val) => setFieldValue("supervisor_id", val)}
                onBlur={handleBlur}
                touched={touched.supervisor_id}
                errors={errors.supervisor_id}
                formstyle="form-input"
              />
            ) : (
              <InputSelect
                label="Supervisor"
                placeholder="Select Supervisor"
                options={[]}
                onBlur={handleBlur}
                touched={touched.supervisor_id}
                errors={errors.supervisor_id}
                formstyle="form-input"
                loading={true}
              />
            )} */}
          </div>
          <div className="col-lg-6">
            <DatePickerInput
              title={trans("Contract Start / End")}
              id="contract_range"
              name="contract_range"
              formstyle="form-input"
              value={
                values.contract_start && values.contract_end
                  ? [dayjs(values.contract_start), dayjs(values.contract_end)]
                  : null
              }
              onChange={({ startDate, endDate }) => {
                setFieldValue(
                  "contract_start",
                  startDate ? dayjs(startDate).toISOString() : ""
                );
                setFieldValue(
                  "contract_end",
                  endDate ? dayjs(endDate).toISOString() : ""
                );
              }}
              onBlur={() => {
                setFieldTouched("contract_start", true);
                setFieldTouched("contract_end", true);
              }}
              errors={errors.contract_start || errors.contract_end}
              touched={touched.contract_start || touched.contract_end}
            />
          </div>
          <div className="col-lg-6 select-z-index">
            <InputSelect
              id="contract_type"
              name="contract_type"
              label="Contract Type"
              placeholder="Select Contract Type"
              options={contractType}
              value={values.contract_type}
              onChange={(val) => setFieldValue("contract_type", val)}
              onBlur={handleBlur}
              touched={touched.contract_type}
              errors={errors.contract_type}
              formstyle="form-input"
            />
          </div>
          <div className="col-lg-6">
            <TimePickerInput
              title={trans("Shift Start")}
              id="shift_start"
              name="shift_start"
              value={values.shift_start}
              errors={errors.shift_start}
              touched={touched.shift_start}
              onChange={(val) => setFieldValue("shift_start", val)}
              onBlur={() => setFieldTouched("shift_start", true)}
              defaultTime={"08:00"}
            />
          </div>
          <div className="col-lg-6">
            <TimePickerInput
              title={trans("Shift End")}
              id="shift_end"
              name="shift_end"
              value={values.shift_end}
              errors={errors.shift_end}
              touched={touched.shift_end}
              onChange={(val) => setFieldValue("shift_end", val)}
              onBlur={() => setFieldTouched("shift_end", true)}
              formstyle="form-input select-z-index"
              defaultTime={"17:00"}
            />
          </div>
          <div className="col-lg-6 select-z-index">
            <InputSelect
              id="working_days"
              name="working_days"
              label={trans("Working Days")}
              placeholder={trans("Select days")}
              mode="multiple"
              options={dayOptions}
              value={values.working_days}
              onChange={(val) => setFieldValue("working_days", val)}
              onBlur={() => setFieldTouched("working_days", true)}
              errors={errors.working_days}
              touched={touched.working_days}
              formstyle="form-input select-z-index"
            />
          </div>
          <div className="col-lg-6">
            <InputDate
              title={trans("Visa expiry date")}
              id="visa_expiry"
              name="visa_expiry"
              onBlur={(value) => setFieldTouched("visa_expiry", true)}
              onChange={(value) =>
                setFieldValue(
                  "visa_expiry",
                  value ? dayjs(value).toISOString() : ""
                )
              }
              errors={errors.visa_expiry}
              touched={touched.visa_expiry}
              value={values.visa_expiry || ""}
            />
          </div>
          <FieldArray name="breaks">
            {({ push, remove }) => (
              <div className="mt-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h5 className="mb-0">{trans("Breaks")}</h5>
                  <Button
                    type="default"
                    icon={<PlusOutlined />}
                    onClick={() => push({ start: "", end: "" })}
                  >
                    {trans("Add Break")}
                  </Button>
                </div>

                {values.breaks.map((brk, idx) => (
                  <div
                    key={idx}
                    className="p-3 mb-3 rounded border position-relative"
                    style={{ background: "#fafafa" }}
                  >
                    <Button
                      type="text"
                      icon={<DeleteOutlined />}
                      className={
                        !isRTL
                          ? "remove-skill position-absolute top-0 end-0 m-1"
                          : "remove-skill position-absolute top-0 start-0 m-1"
                      }
                      danger
                      onClick={() => remove(idx)}
                    />

                    <div className="row mt-30">
                      <div className="col-lg-6">
                        <div className={`position-relative`}>
                          <TimePicker
                            format="HH:mm"
                            minuteStep={5}
                            value={
                              values.breaks?.[idx]?.start
                                ? dayjs(values.breaks[idx].start, "HH:mm")
                                : null
                            }
                            onChange={(time) =>
                              setFieldValue(
                                `breaks[${idx}].start`,
                                time ? time.format("HH:mm") : ""
                              )
                            }
                            onBlur={() =>
                              setFieldTouched(`breaks[${idx}].start`, true)
                            }
                            placeholder={trans("Break start")}
                            className="w-100"
                          />
                          {errors.breaks?.[idx]?.start &&
                            touched.breaks?.[idx]?.start && (
                              <div className="validation">
                                {trans(errors.breaks[idx].start)}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className={`position-relative`}>
                          <TimePicker
                            format="HH:mm"
                            minuteStep={5}
                            value={
                              values.breaks?.[idx]?.end
                                ? dayjs(values.breaks[idx].end, "HH:mm")
                                : null
                            }
                            onChange={(time) =>
                              setFieldValue(
                                `breaks[${idx}].end`,
                                time ? time.format("HH:mm") : ""
                              )
                            }
                            onBlur={() =>
                              setFieldTouched(`breaks[${idx}].end`, true)
                            }
                            className="w-100"
                            placeholder={trans("Break end")}
                          />
                          {errors.breaks?.[idx]?.end &&
                            touched.breaks?.[idx]?.end && (
                              <div className="validation">
                                {trans(errors.breaks[idx].end)}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </FieldArray>
          <FileUploader
            file={values.documents}
            onFileSelect={handleFileChange}
            multiple={true}
            sizeMB={5}
            label={trans("Upload hiring document")}
          />
          {isEditing &&
            oldDocuments.length > 0 &&
            oldDocuments
              .filter((doc) => !removedDocs.includes(doc.path))
              .map((doc, index) => (
                <UploadedDocuments
                  key={index}
                  document={doc}
                  onDelete={() => {
                    setRemovedDocs((prev) => [...prev, doc.path]);
                  }}
                />
              ))}
        </div>
      </div>
      <ShiftPopup
        openShiftPopup={openShiftPopup}
        setOpenShiftPopup={setOpenShiftPopup}
      />
    </>
  );
}

function DeviceAssignmentStep() {
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext();

  // Get context values
  const { currentTechnicianId, isEditing } = useContext(popupcontext);

  // State for hardware type filter
  const [hardwareTypeFilter, setHardwareTypeFilter] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Get current technician data for edit mode
  const { data: editData } = useGetSingleTechnicianQuery(currentTechnicianId, {
    skip: !currentTechnicianId || !isEditing,
  });

  // Fetch available devices with filters
  const { data: devicesData, isFetching: devicesLoading } =
    useGetAvailableDevicesQuery({
      hardware_types: hardwareTypeFilter.join(","),
      search: searchTerm,
      page: 1,
      limit: 100,
    });

  // Get current assignment - check multiple possible locations
  const currentAssignment = React.useMemo(() => {
    if (!isEditing || !editData?.technician) return null;

    const tech = editData.technician;

    // Check if device_assignment exists as a separate object
    if (tech.device_assignment) {
      return tech.device_assignment;
    }

    // Check if assignment data is directly on technician object
    if (
      tech.device_assignment_option ||
      tech.existing_device_id ||
      tech.hardware_device_name ||
      tech.device_id
    ) {
      const assignment = {
        device_assignment_option: tech.device_assignment_option,
        existing_device_id: tech.existing_device_id,
        hardware_device_name: tech.hardware_device_name,
        hardware_device_uniqueid: tech.hardware_device_uniqueid,
        hardware_device_type: tech.hardware_device_type,
        assignment_reason: tech.assignment_reason,
        device_id: tech.device_id,
        device_info: tech.device_info,
      };

      // Map device info to the expected fields - ALWAYS set these fields
      assignment.device_name =
        tech.device_info?.name ||
        tech.hardware_device_name ||
        tech.device_name ||
        "Unknown Device";
      assignment.device_type_display =
        tech.device_info?.display_type ||
        tech.device_info?.hardware_type ||
        tech.hardware_device_type ||
        "Unknown Type";
      assignment.device_uniqueid =
        tech.device_info?.uniqueid ||
        tech.hardware_device_uniqueid ||
        tech.device_uniqueid ||
        "Unknown ID";

      return assignment;
    }

    return null;
  }, [isEditing, editData]);

  // Enhanced device assignment options for edit mode
  const getDeviceAssignmentOptions = () => {
    const baseOptions = [
      { label: trans("Assign Existing Device"), value: "assign_existing" },
      { label: trans("Register New Hardware"), value: "register_hardware" },
      { label: trans("Enable Mobile App"), value: "enable_mobile" },
      { label: trans("No Device"), value: "no_device" },
    ];

    if (isEditing && currentAssignment) {
      return [
        { label: trans("Keep Current Status"), value: "keep_current" },
        { label: trans("Change to Existing Device"), value: "assign_existing" },
        { label: trans("Change to New Hardware"), value: "register_hardware" },
        { label: trans("Change to Mobile App"), value: "enable_mobile" },
        { label: trans("Remove Device Assignment"), value: "unassign_device" },
      ];
    }

    return baseOptions;
  };

  const deviceAssignmentOptions = getDeviceAssignmentOptions();

  // Set initial value for edit mode
  React.useEffect(() => {
    if (isEditing && currentAssignment && !values.device_assignment_option) {
      setFieldValue("device_assignment_option", "keep_current");
    }
  }, [
    isEditing,
    currentAssignment,
    values.device_assignment_option,
    setFieldValue,
  ]);

  const handleDeviceOptionChange = (option) => {
    setFieldValue("device_assignment_option", option);

    // Reset conditional fields when option changes
    if (option !== "keep_current") {
      setFieldValue("existing_device_id", "");
      setFieldValue("hardware_device_name", "");
      setFieldValue("hardware_device_uniqueid", "");
      setFieldValue("hardware_device_type", "");
      setFieldValue("assignment_reason", "");
      setFieldValue("unassignment_reason", "");
    }
  };

  // Hardware type options for filter dropdown
  const hardwareTypeFilterOptions = [
    { label: trans("Personal Tracker"), value: "personal_tracker" },
    { label: trans("Wearable Tracker"), value: "wearable_tracker" },
    { label: trans("Handheld GPS"), value: "handheld_gps" },
    { label: trans("Safety Beacon"), value: "safety_beacon" },
    { label: trans("Asset Tag"), value: "asset_tag" },
    { label: trans("Mobile"), value: "mobile" },
    { label: trans("Tablet"), value: "tablet" },
  ];

  // Format devices for dropdown
  const availableDevicesOptions =
    devicesData?.devices?.map((device) => ({
      label: `${device.name} (${device.uniqueid}) - ${device.device_type_display}`,
      value: device.id,
      device: device,
    })) || [];

  // Render current assignment info for edit mode
  const renderCurrentAssignment = () => {
    if (!isEditing || !currentAssignment) {
      return null;
    }
    // Special case: "no_device"
    if (currentAssignment.device_assignment_option === "no_device") {
      return (
        <div className="col-12 mb-3">
          <div className="alert alert-success d-flex align-items-start">
            <i className="fas fa-info-circle me-2 mt-1"></i>
            <div>
              <h6 className="mb-1">{trans("No Device Assignment")}</h6>
              <p className="mb-0">
                {trans(
                  "This technician currently has no device assigned. You can assign a device using the options below if needed."
                )}
              </p>
            </div>
          </div>
        </div>
      );
    }

    // Check if there's any assignment to display
    const hasAssignment =
      currentAssignment.existing_device_id ||
      currentAssignment.hardware_device_name ||
      currentAssignment.device_assignment_option === "enable_mobile";

    if (!hasAssignment && !currentAssignment.device_assignment_option) {
      return (
        <div className="col-12 mb-3">
          <div className="alert alert-success">
            <h6 className="mb-0">{trans("No Current Device Assignment")}</h6>
            <p className="mb-0 mt-1">
              {trans("This technician currently has no device assigned.")}
            </p>
          </div>
        </div>
      );
    }

    // Determine assignment type display
    let assignmentTypeDisplay = trans("Unknown");
    let deviceName = trans("N/A");
    let deviceType = trans("N/A");
    let uniqueId = trans("N/A");

    if (
      currentAssignment.device_assignment_option === "assign_existing" ||
      currentAssignment.existing_device_id
    ) {
      assignmentTypeDisplay = trans("Existing Device");
      deviceName = currentAssignment.device_name || trans("Unknown Device");
      deviceType =
        currentAssignment.device_type_display || trans("Unknown Type");
      uniqueId = currentAssignment.device_uniqueid || trans("Unknown ID");
    } else if (
      currentAssignment.device_assignment_option === "register_hardware" ||
      currentAssignment.hardware_device_name
    ) {
      assignmentTypeDisplay = trans("Registered Hardware Device");
      deviceName =
        currentAssignment.device_name ||
        currentAssignment.hardware_device_name ||
        trans("Unknown Device");
      deviceType =
        currentAssignment.device_type_display ||
        currentAssignment.hardware_device_type ||
        trans("Unknown Type");
      uniqueId =
        currentAssignment.device_uniqueid ||
        currentAssignment.hardware_device_uniqueid ||
        trans("Unknown ID");
    } else if (currentAssignment.device_assignment_option === "enable_mobile") {
      assignmentTypeDisplay = trans("Mobile App Access");
      deviceName = trans("Mobile App");
      deviceType = trans("Mobile Application");
      uniqueId = trans("N/A");
    }

    return (
      <div className="col-12 mb-3">
        <div className="card border-primary">
          <div className="card-header bg-primary text-white">
            <h6 className="mb-0">{trans("Current Device Assignment")}</h6>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <p className="mb-2">
                  <strong>{trans("Assignment Type")}:</strong>{" "}
                  {assignmentTypeDisplay}
                </p>
                <p className="mb-2">
                  <strong>{trans("Device Name")}:</strong> {deviceName}
                </p>
              </div>
              <div className="col-md-6">
                <p className="mb-2">
                  <strong>{trans("Device Type")}:</strong> {deviceType}
                </p>
                <p className="mb-2">
                  <strong>{trans("Unique ID")}:</strong> {uniqueId}
                </p>
              </div>
            </div>
            {currentAssignment.assignment_reason && (
              <p className="mb-0">
                <strong>{trans("Assignment Reason")}:</strong>{" "}
                {currentAssignment.assignment_reason}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Debug logging
  console.log("DeviceAssignmentStep render:", {
    isEditing,
    currentTechnicianId,
    editData: !!editData,
    currentAssignment,
    deviceAssignmentOptions,
    currentValue: values.device_assignment_option,
  });

  return (
    <div className="form-section">
      <div className="row">
        <div className="col-12">
          <h5 className="mb-3">{trans("Device Assignment")}</h5>
        </div>

        {renderCurrentAssignment()}

        <div className="col-lg-6 select-z-index">
          <InputSelect
            id="device_assignment_option"
            name="device_assignment_option"
            label={
              isEditing
                ? trans("Device Assignment Action")
                : trans("Device Assignment Option")
            }
            placeholder={
              isEditing
                ? trans("Select device assignment action")
                : trans("Select device assignment option")
            }
            options={deviceAssignmentOptions}
            value={values.device_assignment_option}
            onChange={handleDeviceOptionChange}
            onBlur={() => setFieldTouched("device_assignment_option", true)}
            errors={errors.device_assignment_option}
            touched={touched.device_assignment_option}
            formstyle="form-input"
          />
        </div>

        {/* Keep Current Assignment - Show confirmation */}
        {values.device_assignment_option === "keep_current" && (
          <div className="col-12">
            <div className="alert alert-success">
              <i className="fas fa-check-circle me-2"></i>
              <strong>{trans("Current assignment will be maintained")}</strong>
              <p className="mb-0 mt-1">
                {trans(
                  "No changes will be made to the current device assignment."
                )}
              </p>
            </div>
          </div>
        )}

        {/* Unassign Device - Show warning and reason */}
        {values.device_assignment_option === "unassign_device" && (
          <>
            <div className="col-12">
              <div className="alert alert-warning">
                <i className="fas fa-exclamation-triangle me-2"></i>
                <strong>{trans("Device will be unassigned")}</strong>
                <p className="mb-0 mt-1">
                  {trans(
                    "The current device will be removed from this technician and become available for reassignment."
                  )}
                </p>
              </div>
            </div>
            <div className="col-lg-12">
              <Input
                title={trans("Unassignment Reason")}
                type="text"
                placeholder={trans(
                  "Enter reason for removing device assignment"
                )}
                formstyle="form-input"
                id="unassignment_reason"
                name="unassignment_reason"
                value={values.unassignment_reason || ""}
                onChange={(e) =>
                  setFieldValue("unassignment_reason", e.target.value)
                }
                onBlur={() => setFieldTouched("unassignment_reason", true)}
                errors={errors.unassignment_reason}
                touched={touched.unassignment_reason}
              />
            </div>
          </>
        )}

        {/* Change to Existing Device */}
        {values.device_assignment_option === "assign_existing" && (
          <>
            <div className="col-12">
              <div className="alert alert-success">
                <i className="fas fa-info-circle me-2"></i>
                {currentAssignment
                  ? trans(
                      "Current device will be replaced with the selected device"
                    )
                  : trans("A device from available inventory will be assigned")}
              </div>
            </div>

            {/* Hardware Type Filter */}
            <div className="col-lg-6 select-z-index">
              <InputSelect
                id="hardware_type_filter"
                name="hardware_type_filter"
                label={trans("Filter by Hardware Type")}
                placeholder={trans("Select hardware types to filter")}
                options={hardwareTypeFilterOptions}
                value={hardwareTypeFilter}
                onChange={setHardwareTypeFilter}
                mode="multiple"
                allowClear={true}
                formstyle="form-input"
              />
            </div>

            {/* Device Selection Dropdown - FIXED onChange handler */}
            <div className="col-lg-6 select-z-index">
              <InputSelect
                id="existing_device_id"
                name="existing_device_id"
                label={trans("Available Devices")}
                placeholder={trans("Select an available device")}
                options={availableDevicesOptions}
                value={values.existing_device_id}
                onChange={(val) => setFieldValue("existing_device_id", val)} // ← FIXED: Now properly sets the value
                onBlur={() => setFieldTouched("existing_device_id", true)}
                errors={errors.existing_device_id}
                touched={touched.existing_device_id}
                formstyle="form-input"
                loading={devicesLoading}
                showSearch={true}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            </div>

            <div className="col-lg-12">
              <Input
                title={trans("Assignment Reason")}
                type="text"
                placeholder={trans("Enter reason for device change")}
                formstyle="form-input"
                id="assignment_reason"
                name="assignment_reason"
                value={values.assignment_reason}
                onChange={(e) =>
                  setFieldValue("assignment_reason", e.target.value)
                }
                onBlur={() => setFieldTouched("assignment_reason", true)}
                errors={errors.assignment_reason}
                touched={touched.assignment_reason}
              />
            </div>
          </>
        )}

        {/* Register New Hardware */}
        {values.device_assignment_option === "register_hardware" && (
          <>
            <div className="col-12">
              <div className="alert alert-success">
                <i className="fas fa-info-circle me-2"></i>
                {currentAssignment
                  ? trans(
                      "Current device will be replaced with a new hardware device"
                    )
                  : trans(
                      "A new hardware device will be registered and assigned"
                    )}
              </div>
            </div>

            <div className="col-lg-6">
              <Input
                title={trans("Hardware Device Name")}
                type="text"
                placeholder={trans("Enter device name")}
                formstyle="form-input"
                id="hardware_device_name"
                name="hardware_device_name"
                value={values.hardware_device_name}
                onChange={(e) =>
                  setFieldValue("hardware_device_name", e.target.value)
                }
                onBlur={() => setFieldTouched("hardware_device_name", true)}
                errors={errors.hardware_device_name}
                touched={touched.hardware_device_name}
              />
            </div>
            <div className="col-lg-6">
              <Input
                title={trans("Hardware Device Unique ID")}
                type="text"
                placeholder={trans("Enter unique device ID")}
                formstyle="form-input"
                id="hardware_device_uniqueid"
                name="hardware_device_uniqueid"
                value={values.hardware_device_uniqueid}
                onChange={(e) =>
                  setFieldValue("hardware_device_uniqueid", e.target.value)
                }
                onBlur={() => setFieldTouched("hardware_device_uniqueid", true)}
                errors={errors.hardware_device_uniqueid}
                touched={touched.hardware_device_uniqueid}
              />
            </div>
            <div className="col-lg-6 select-z-index">
              <InputSelect
                id="hardware_device_type"
                name="hardware_device_type"
                label={trans("Hardware Device Type")}
                placeholder={trans("Select device type")}
                options={hardwareDeviceTypes}
                value={values.hardware_device_type}
                onChange={(val) => setFieldValue("hardware_device_type", val)}
                onBlur={() => setFieldTouched("hardware_device_type", true)}
                errors={errors.hardware_device_type}
                touched={touched.hardware_device_type}
                formstyle="form-input"
              />
            </div>
            <div className="col-lg-12">
              <Input
                title={trans("Assignment Reason")}
                type="text"
                placeholder={trans("Enter reason for new hardware assignment")}
                formstyle="form-input"
                id="assignment_reason"
                name="assignment_reason"
                value={values.assignment_reason}
                onChange={(e) =>
                  setFieldValue("assignment_reason", e.target.value)
                }
                onBlur={() => setFieldTouched("assignment_reason", true)}
                errors={errors.assignment_reason}
                touched={touched.assignment_reason}
              />
            </div>
          </>
        )}

        {/* Enable Mobile App */}
        {values.device_assignment_option === "enable_mobile" && (
          <div className="col-12">
            <div className="alert alert-success">
              <i className="fas fa-mobile-alt me-2"></i>
              {currentAssignment
                ? trans(
                    "Current device will be replaced with mobile app access"
                  )
                : trans(
                    "Mobile app access will be enabled for this technician"
                  )}
              <p className="mb-0 mt-1">
                {trans(
                  "They will receive registration details after the change is saved."
                )}
              </p>
            </div>
          </div>
        )}

        {/* No Device */}
        {values.device_assignment_option === "no_device" &&
          currentAssignment &&
          currentAssignment.device_assignment_option !== "no_device" && (
            <div className="col-12">
              <div className="alert alert-warning">
                <i className="fas fa-times-circle me-2"></i>
                {trans(
                  "Current device will be removed and no new device will be assigned"
                )}
                <p className="mb-0 mt-1">
                  {trans("Device assignment can be done later if needed.")}
                </p>
              </div>
            </div>
          )}

        {/* Device Summary */}
        {values.device_assignment_option === "assign_existing" &&
          devicesData && (
            <div className="col-12 mt-3">
              <div className="alert alert-success">
                <h6 className="mb-2">{trans("Device Summary:")}</h6>
                <div className="row">
                  <div className="col-md-6">
                    <p className="mb-1">
                      <strong>{trans("Filtered Devices:")}</strong>{" "}
                      {devicesData.stats?.total_filtered_devices || 0}
                    </p>
                    <p className="mb-1">
                      <strong>{trans("Compatible Devices:")}</strong>{" "}
                      {devicesData.stats?.total_compatible_devices || 0}
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-1">
                      <strong>{trans("Total Access:")}</strong>{" "}
                      {devicesData.stats?.total_linked_devices || 0}
                    </p>
                    <p className="mb-1">
                      <strong>{trans("Currently Assigned:")}</strong>{" "}
                      {devicesData.stats?.total_assigned_devices || 0}
                    </p>
                  </div>
                </div>
                {(hardwareTypeFilter.length > 0 || searchTerm) && (
                  <div className="mt-2">
                    <small className="text-muted">
                      <strong>{trans("Active Filters:")}</strong>
                      {hardwareTypeFilter.length > 0 && (
                        <span>
                          {" "}
                          {trans("Hardware Types")}:{" "}
                          {hardwareTypeFilter.join(", ")}
                        </span>
                      )}
                      {searchTerm && (
                        <span>
                          {" "}
                          {trans("Search")}: "{searchTerm}"
                        </span>
                      )}
                    </small>
                  </div>
                )}
              </div>
            </div>
          )}
      </div>
    </div>
  );
}
function SystemDetailsStep({
  generatePassword,
  setGeneratePassword,
  isEditing,
}) {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } =
    useFormikContext();
  return (
    <div className="form-section">
      <div className="row">
        <div className="col-lg-6">
          <Input
            title={trans("Email")}
            type="email"
            placeholder="Ex@gmail.com"
            formstyle="form-input"
            id="email"
            name="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.email}
            touched={touched.email}
            disabled={true}
          />
        </div>
        <div className="col-lg-6 select-z-index">
          <InputSelect
            id="role"
            name="role"
            label={trans("role")}
            options={roles}
            value={values.role}
            onChange={(val) => setFieldValue("role", val)}
            onBlur={handleBlur}
            touched={touched.role}
            errors={errors.role}
            formstyle="form-input"
            showSearch={false}
            allowClear={false}
          />
        </div>
        <div className="col-lg-6">
          <Input
            title={isEditing ? trans("Change Password") : trans("Password")}
            type="password"
            placeholder={trans("********")}
            formstyle="form-input"
            id="password"
            name="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            errors={errors.password}
            touched={touched.password}
            disabled={generatePassword}
          />
        </div>
        {!isEditing && (
          <div className="col-lg-6">
            <div className={`position-relative form-input mb-2`}>
              <label className="form-label">
                {trans("Generate Random Password")}
              </label>
              <div className="d-block">
                <div className="d-flex align-content-center mb-2">
                  <label className={`switch`}>
                    <input
                      className="form-control"
                      type="checkbox"
                      name=""
                      onChange={(e) => {
                        setGeneratePassword(e.target.checked);
                        setFieldValue("password", "");
                        setFieldValue("generate_password", e.target.checked);
                      }}
                      autoFocus
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="col-lg-6">
          <div className={`position-relative form-input mb-2`}>
            <label className="form-label">{trans("On Call")}</label>
            <div className="d-block">
              <div className="d-flex align-content-center mb-2">
                <label className={`switch`}>
                  <input
                    className="form-control"
                    type="checkbox"
                    id="on_call"
                    name="on_call"
                    checked={values.on_call}
                    onChange={(e) => setFieldValue("on_call", e.target.checked)}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function TechnicianForm() {
  const { form, isEditing, handleClose, currentTechnicianId, setEdited } =
    useContext(popupcontext);
  const [currentStep, setCurrentStep] = useState(0);
  const isLastStep = currentStep === steps.length - 1;
  const [generatePassword, setGeneratePassword] = useState(false);
  const [registerTechnician, { isLoading }] = useRegisterTechnicianMutation();
  const [editTechnician, { isLoading: editLoading }] =
    useEditTechnicianMutation();
  const { refetch, data: editData } = useGetSingleTechnicianQuery(
    currentTechnicianId,
    { skip: !currentTechnicianId }
  );
  const [picUpdated, setPicUpdated] = useState(false);
  const [deleteAttachment] = useDeleteAttachmentMutation();
  const [removedDocs, setRemovedDocs] = useState([]);

  useEffect(() => {
    if (isEditing && currentTechnicianId) {
      refetch();
    }
  }, [isEditing, form]);

  let initialValues = {};
  if (isEditing && editData?.technician) {
    initialValues = {
      // Step 1: Personal Details
      name: editData?.technician.name || "",
      email: editData?.technician.email || "",
      phone: editData?.technician.phone || "",
      national_id: editData?.technician.national_id || "",
      employee_id: editData?.technician.employee_id || "",
      specialization: editData?.technician.specialization || "",
      skills: editData?.technician.skills || "",
      profile_photo: editData?.technician.profile_photo || "",
      // Step 2: Job Info
      job_title: editData?.technician.job_title || "",
      department: editData?.technician.department || "",
      work_location: editData?.technician.work_location || "",
      // supervisor_id: editData?.technician.supervisor_id
      //   ? Number(editData.technician.supervisor_id)
      //   : "",
      shift_start: formatTimeFromDate(editData?.technician.shift_start) || "",
      shift_end: formatTimeFromDate(editData?.technician.shift_end) || "",
      working_days: editData?.technician.working_days || "",
      breaks:
        editData?.technician.breaks?.map((b) => ({
          start: formatTimeFromDate(b.start),
          end: formatTimeFromDate(b.end),
        })) || [],
      on_call: editData?.technician.on_call || "",
      contract_type: editData?.technician.contract_type || "",
      contract_start: editData?.technician.contract_start || null,
      contract_end: editData?.technician.contract_end || null,
      visa_expiry: editData?.technician.visa_expiry || null,
      // Step 3: Device Assignment
      device_assignment_option:
        editData?.technician.device_assignment_option || "no_device",
      existing_device_id: editData?.technician.existing_device_id || "",
      hardware_device_name: editData?.technician.hardware_device_name || "",
      hardware_device_uniqueid:
        editData?.technician.hardware_device_uniqueid || "",
      hardware_device_type: editData?.technician.hardware_device_type || "",
      assignment_reason: editData?.technician.assignment_reason || "",
      // Step 4: System Access
      role: editData?.technician.role || "",
    };
  } else {
    initialValues = {
      // Step 1: Personal Details
      name: "",
      email: "",
      phone: "",
      national_id: "",
      employee_id: "",
      specialization: "",
      skills: [],
      profile_photo: null,
      // Step 2: Job Info
      job_title: "",
      department: "",
      work_location: "",
      // supervisor_id: "",
      shift_start: "08:00",
      shift_end: "17:00",
      working_days: [],
      breaks: [],
      on_call: false,
      contract_start: null,
      contract_end: null,
      contract_type: "",
      visa_expiry: null,
      documents: [],
      // Step 3: Device Assignment
      device_assignment_option: "no_device",
      existing_device_id: "",
      hardware_device_name: "",
      hardware_device_uniqueid: "",
      hardware_device_type: "",
      assignment_reason: "",
      // Step 4: System Access
      password: "",
      role: "",
      generate_password: false,
    };
  }

  const skillSchema = Yup.object({
    skill: Yup.string()
      .required(trans("Skill is required"))
      .matches(/^[^\s]/, trans("cannot start with a space")),
    skill_level: Yup.string().required(trans("Skill level is required")),
    description: Yup.string(),
  });

  const breakSchema = Yup.object({
    start: Yup.string().required(trans("Break start is required")),
    end: Yup.string().required(trans("Break end is required")),
  });

  const validationSchemas = [
    // First Step Validation
    Yup.object({
      name: Yup.string()
        .required(trans("Name is required"))
        .matches(/^[^\s]/, trans("cannot start with a space")),
      email: Yup.string().email().required(trans("Email Is Required")),
      phone: Yup.string().required(trans("Phone is Required")),
      national_id: Yup.string()
        .required(trans("National ID is Required"))
        .matches(/^[^\s]/, trans("cannot start with a space")),
      employee_id: Yup.string()
        .required(trans("Employee Code is Required"))
        .matches(/^[^\s]/, trans("cannot start with a space")),
      specialization: Yup.string().required(
        trans("Specialization is Required")
      ),
      skills: Yup.array().of(skillSchema).notRequired(),
      profile_photo: Yup.mixed().nullable(),
    }),
    // Second Step Validation
    Yup.object({
      job_title: Yup.string().notRequired(),
      department: Yup.string().notRequired(),
      work_location: Yup.string().required(trans("Work Location is Required")),
      // supervisor_id: Yup.string().required(trans("Supervisor is Required")),
      contract_start: Yup.date().notRequired(),
      contract_end: Yup.date().notRequired(),
      contract_type: Yup.string().required(trans("Contract Type is Required")),
      visa_expiry: Yup.date().notRequired(),
      shift_start: Yup.string().required(trans("Shift Start time is required")),
      shift_end: Yup.string().required(trans("Shift End time is required")),
      working_days: Yup.array().min(1, trans("Select at least 1 day")),
      breaks: Yup.array().of(breakSchema).notRequired(),
      documents: Yup.array().of(Yup.mixed()).notRequired(),
    }),
    // Third Step Validation (Device Assignment)
    Yup.object({
      device_assignment_option: Yup.string()
        .oneOf([
          "assign_existing",
          "register_hardware",
          "enable_mobile",
          "no_device",
          "keep_current",
          "unassign_device",
        ])
        .required(trans("Device assignment option is required")),
      // existing_device_id: Yup.string().when("device_assignment_option", {
      //   is: "assign_existing",
      //   then: (schema) => schema.required(trans("Device is required")),
      //   otherwise: (schema) => schema.notRequired(),
      // }),
      hardware_device_name: Yup.string().when("device_assignment_option", {
        is: "register_hardware",
        then: (schema) => schema.required(trans("Device name is required")),
        otherwise: (schema) => schema.notRequired(),
      }),
      hardware_device_uniqueid: Yup.string().when("device_assignment_option", {
        is: "register_hardware",
        then: (schema) =>
          schema.required(trans("Device unique ID is required")),
        otherwise: (schema) => schema.notRequired(),
      }),
      hardware_device_type: Yup.string().when("device_assignment_option", {
        is: "register_hardware",
        then: (schema) =>
          schema
            .oneOf([
              "personal_tracker",
              "wearable_tracker",
              "handheld_gps",
              "safety_beacon",
              "asset_tag",
              "mobile",
              "tablet",
            ])
            .optional(),
        otherwise: (schema) => schema.notRequired(),
      }),
      assignment_reason: Yup.string().notRequired(),
    }),
    // Fourth Step Validation (System Access)
    Yup.object({
      email: Yup.string()
        .email()
        .required(trans("Email is required in technician details")),
      role: Yup.string().required(trans("Role is required")),
      ...(isEditing
        ? {
            password: Yup.string()
              .notRequired()
              .min(8, trans("Password must be at least 8 characters")),
          }
        : {
            password: Yup.string().when("generate_password", {
              is: false,
              then: (schema) =>
                schema
                  .required(trans("Password is required"))
                  .min(8, trans("Password must be at least 8 characters")),
              otherwise: (schema) => schema.notRequired(),
            }),
          }),
    }),
  ];

  const goNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const goBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const renderStepComponent = () => {
    switch (currentStep) {
      case 0:
        return <PersonalDetailsStep setPicUpdated={setPicUpdated} />;
      case 1:
        return (
          <JobDetailsStep
            isEditing={isEditing}
            oldDocuments={editData?.technician.documents || []}
            removedDocs={removedDocs}
            setRemovedDocs={setRemovedDocs}
          />
        );
      case 2:
        return <DeviceAssignmentStep />;
      case 3:
        return (
          <SystemDetailsStep
            isEditing={isEditing}
            generatePassword={generatePassword}
            setGeneratePassword={setGeneratePassword}
          />
        );
      default:
        return null;
    }
  };

  const makeAllTouched = (err) => {
    if (typeof err === "string") return true;
    if (Array.isArray(err)) return err.map(makeAllTouched);
    if (err && typeof err === "object") {
      const out = {};
      Object.keys(err).forEach((k) => {
        out[k] = makeAllTouched(err[k]);
      });
      return out;
    }
    return true;
  };

  if (isEditing && !editData?.technician) return <Loader />;

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchemas[currentStep]}
      enableReinitialize
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        const originalPhoto = editData?.technician?.profile_photo;
        const profilePhotoDeleted =
          isEditing && originalPhoto && !values.profile_photo;

        if (!isLastStep && !isEditing) {
          setCurrentStep(currentStep + 1);
          return;
        }

        try {
          setSubmitting(true);
          if (profilePhotoDeleted) {
            await deleteAttachment({
              id: currentTechnicianId,
              fileType: "profile_photo",
              filePath: originalPhoto,
            }).unwrap();
          }

          for (const documentPath of removedDocs) {
            await deleteAttachment({
              id: currentTechnicianId,
              fileType: "documents",
              filePath: documentPath,
            }).unwrap();
          }
          setRemovedDocs([]);

          const fd = new FormData();

          const primitives = [
            "name",
            "email",
            "phone",
            "national_id",
            "employee_id",
            "specialization",
            "job_title",
            "department",
            "work_location",
            // "supervisor_id",
            "contract_type",
            "shift_start",
            "shift_end",
            "role",
            "device_assignment_option",
            "existing_device_id",
            "hardware_device_name",
            "hardware_device_uniqueid",
            "hardware_device_type",
            "assignment_reason",
            "unassignment_reason", // Add this line
          ];
          primitives.forEach(
            (k) =>
              values[k] != null && values[k] !== "" && fd.append(k, values[k])
          );

          if (values.profile_photo instanceof File) {
            fd.append("profile_photo", values.profile_photo);
          }

          fd.append(
            "contract_start",
            values.contract_start !== null
              ? dayjs(values.contract_start).format("YYYY-MM-DD")
              : ""
          );
          fd.append(
            "contract_end",
            values.contract_end !== null
              ? dayjs(values.contract_end).format("YYYY-MM-DD")
              : ""
          );
          fd.append(
            "visa_expiry",
            values.visa_expiry !== null
              ? dayjs(values.visa_expiry).format("YYYY-MM-DD")
              : ""
          );

          fd.append("breaks", JSON.stringify(values.breaks));
          fd.append(
            "skills",
            JSON.stringify(
              values.skills.map(({ skill, skill_level, description }) => ({
                skill,
                skill_level,
                description,
              }))
            )
          );

          fd.append("working_days", JSON.stringify(values.working_days));

          if (isEditing && values.password?.trim()) {
            fd.append("password", values.password);
          } else if (!isEditing) {
            fd.append("password", values.password);
          }
          if (!isEditing) {
            fd.append("generate_password", values.generate_password);
          }
          fd.append("on_call", values.on_call);

          if (Array.isArray(values.documents)) {
            values.documents.forEach((file) => {
              if (file instanceof File) {
                fd.append("documents", file);
              }
            });
          }
          if (!isEditing) {
            await registerTechnician(fd).unwrap();
            toast.success(trans("Technician created successfully"), {
              autoClose: 800,
              rtl: localStorage.getItem("lang") === "ar" ? true : false,
            });
          } else {
            await editTechnician({
              id: currentTechnicianId,
              formData: fd,
            }).unwrap();
            toast.success(trans("Technician edited successfully"), {
              autoClose: 800,
              rtl: localStorage.getItem("lang") === "ar" ? true : false,
            });
          }
          resetForm();
          handleClose("form");
          setCurrentStep(0);
          setEdited(true);
        } catch (err) {
          let errorMsg = trans(
            // Check for validation errors (array format) - THIS handles your current error
            (err?.data?.error &&
              Array.isArray(err.data.error) &&
              err.data.error[0]) ||
              // Standard message field
              err?.data?.message ||
              // Alternative locations
              err?.response?.data?.message ||
              err?.message ||
              // Fallback
              "Something went wrong"
          );
          toast.error(errorMsg, {
            autoClose: 800,
            rtl: localStorage.getItem("lang") === "ar" ? true : false,
          });
        }
      }}
    >
      {({
        validateForm,
        setTouched,
        handleSubmit,
        resetForm,
        isSubmitting,
      }) => {
        const handleFormClose = () => {
          resetForm();
          handleClose("form");
          setCurrentStep(0);
        };
        return (
          <Form show={form} className={"multi-tab-form"}>
            <Offcanvas.Header>
              <FormHeader
                title={
                  isEditing
                    ? trans("Edit technician")
                    : trans("Add new technician")
                }
                onClose={() => handleFormClose()}
              />
            </Offcanvas.Header>
            <div className="H-line"></div>
            <Offcanvas.Body>
              <div className="step-navigation mb-3">
                <Segmented
                  options={steps.map((step, index) => ({
                    label: step,
                    value: step,
                    disabled: !isEditing && index > currentStep + 1,
                  }))}
                  value={steps[currentStep]}
                  onChange={async (val) => {
                    const nextStepIndex = steps.indexOf(val);

                    if (nextStepIndex === currentStep) return;

                    const errs = await validateForm();
                    const hasErrors = Object.keys(errs).length > 0;

                    if (!hasErrors) {
                      setCurrentStep(nextStepIndex);
                    } else {
                      setTouched(makeAllTouched(errs), true);
                    }
                  }}
                  size="large"
                  block
                />
              </div>
              <FormikForm dir={!isRTL ? "ltr" : "rtl"}>
                {renderStepComponent()}
                <div className="offcanvas-footer m-0 flex-between">
                  <Button
                    type={"default"}
                    htmlType="button"
                    onClick={goBack}
                    disabled={currentStep === 0}
                  >
                    {trans("Previous")}
                  </Button>
                  {isLastStep ? (
                    <Button
                      type={"primary"}
                      htmlType="submit"
                      onClick={handleSubmit}
                      loading={isSubmitting}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? trans("Saving...") : trans("Save")}
                    </Button>
                  ) : (
                    <Flex vertical={false} gap={"8px"}>
                      {isEditing && (
                        <Button
                          type={"default"}
                          htmlType="submit"
                          onClick={handleSubmit}
                          loading={isSubmitting}
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? trans("Saving...") : trans("Save")}
                        </Button>
                      )}
                      <Button
                        type={"primary"}
                        htmlType="button"
                        onClick={async () => {
                          const errs = await validateForm();
                          const hasErrors = Object.keys(errs).length > 0;

                          if (!hasErrors) {
                            goNext();
                          } else {
                            setTouched(makeAllTouched(errs), true);
                          }
                        }}
                      >
                        {trans("Next")}
                      </Button>
                    </Flex>
                  )}
                </div>
              </FormikForm>
            </Offcanvas.Body>
          </Form>
        );
      }}
    </Formik>
  );
}
